import React, { useState } from "react";
import "../CSS/CreateAccount.css";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import logo from "../../assets/icone.png";

const CreateAccount = () => {
  const [formData, setFormData] = useState({
    fullName: "",
    idNumber: "",
    phone: "",
    placementCounty: "",
    institution: "",
    currentCounty: "",
    course: "",
    password: "",
    confirmPassword: "",
    insurance: "",
    email:""
  });

  const [cv, setCv] = useState(null);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  const navigate = useNavigate();

    
    const handleNavigation = (destination) => {
   // alert("Navigate to:", destination);
  
      // Replace these with your React Router routes:
      //
       navigate(`/${destination}`);
      // navigate("/agent-login");
      // navigate("/employer");
      // navigate("/opportunities");
    };

  const counties = [
    "Baringo",
    "Bomet",
    "Bungoma",
    "Busia",
    "Elgeyo-Marakwet",
    "Embu",
    "Garissa",
    "Homa Bay",
    "Isiolo",
    "Kajiado",
    "Kakamega",
    "Kericho",
    "Kiambu",
    "Kilifi",
    "Kirinyaga",
    "Kisii",
    "Kisumu",
    "Kitui",
    "Kwale",
    "Laikipia",
    "Lamu",
    "Machakos",
    "Makueni",
    "Mandera",
    "Marsabit",
    "Meru",
    "Migori",
    "Mombasa",
    "Murang'a",
    "Nairobi",
    "Nakuru",
    "Nandi",
    "Narok",
    "Nyamira",
    "Nyandarua",
    "Nyeri",
    "Samburu",
    "Siaya",
    "Taita-Taveta",
    "Tana River",
    "Tharaka-Nithi",
    "Trans Nzoia",
    "Turkana",
    "Uasin Gishu",
    "Vihiga",
    "Wajir",
    "West Pokot",
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const handleCVUpload = (e) => {
    const file = e.target.files[0];

    if (!file) return;

    if (file.size > 5 * 1024 * 1024) {
      setErrors((prev) => ({
        ...prev,
        cv: "CV must be smaller than 5MB.",
      }));
      return;
    }

    const allowedTypes = [
      "application/pdf",
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    ];

    if (!allowedTypes.includes(file.type)) {
      setErrors((prev) => ({
        ...prev,
        cv: "Please upload a PDF or Word document.",
      }));
      return;
    }

    setCv(file);

    setErrors((prev) => ({
      ...prev,
      cv: "",
    }));
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.fullName.trim()) {
      newErrors.fullName = "Full name is required.";
    }

    if (!formData.idNumber.trim()) {
      newErrors.idNumber = "ID number is required.";
    }

    if (!formData.phone.trim()) {
      newErrors.phone = "Phone number is required.";
    }

    if (!formData.placementCounty) {
      newErrors.placementCounty = "Select a county.";
    }

    if (!formData.institution.trim()) {
      newErrors.institution = "Institute name is required.";
    }

    if (!formData.currentCounty) {
      newErrors.currentCounty = "Select your current county.";
    }

    if (!formData.email) {
      newErrors.currentCounty = "Please insert your email.";
    }


    if (!formData.course.trim()) {
      newErrors.course = "Current course is required.";
    }

    if (!formData.password) {
      newErrors.password = "Password is required.";
    } else if (formData.password.length < 8) {
      newErrors.password = "Password must be at least 8 characters.";
    }

    if (!formData.confirmPassword) {
      newErrors.confirmPassword = "Please confirm your password.";
    } else if (formData.password !== formData.confirmPassword) {
      newErrors.confirmPassword = "Passwords do not match.";
    }

    if (!cv) {
      newErrors.cv = "Please upload your CV.";
    }

 

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    setIsSubmitting(true);

    try {
      const data = new FormData();

      data.append("fullName", formData.fullName);
      data.append("email", formData.email);
      data.append("idNumber", formData.idNumber);
      data.append("phone", formData.phone);
      data.append("placementCounty", formData.placementCounty);
      data.append("institution", formData.institution);
      data.append("currentCounty", formData.currentCounty);
      data.append("course", formData.course);
      data.append("password", formData.password);
      data.append("insurance", formData.insurance);

      if (cv) {
        data.append("cv", cv);
      }

    
    

        const response = await fetch(
          "https://advenwarecareerlink.com/acl/My_account/create_account.php",
          {
            method: "POST",
            body: data,
          }
        );

        const result = await response.json();

      //  alert(result.message)
      
       if(result.message == "ok")
       {
          
         const login = () => {
          Cookies.set("userID", `${result.ID}`, {
            expires: 7 * 42
         });

        
        };

       login()

     //  alert(result.ID)
          alert('your account creation was a sucess')
          handleNavigation('/')

       }

       else{
           alert('no')
       }

    } catch (error) {
      console.error(error);
      alert("Something went wrong. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="register-page">

      {/* LEFT SIDE */}
      <section className="register-intro">

        <div className="intro-overlay"></div>

        <div className="intro-content">

          <div className="brand">
               <img
                                                    src={logo}
                                                    alt="Advenware Career Link"
                                                    className="landing-logo-image"
                          />

            <div>
              <h2>Advenware</h2>
              <p>Careere Link</p>
            </div>
          </div>

          <div className="intro-main">

            <div className="small-label">
              STUDENT CAREER NETWORK
            </div>

            <h1>
              Turn your education
              <span> into opportunity.</span>
            </h1>

            <p>
              Create your student profile and connect with organizations
              offering attachment and career opportunities across Kenya.
            </p>

            <div className="benefits">

              <div className="benefit">
                <div className="benefit-icon">✓</div>

                <div>
                  <h4>Find attachment opportunities</h4>
                  <p>
                    Discover opportunities that match your course and skills.
                  </p>
                </div>
              </div>

              <div className="benefit">
                <div className="benefit-icon">✓</div>

                <div>
                  <h4>Build your career profile</h4>
                  <p>
                    Showcase your CV and academic background to employers.
                  </p>
                </div>
              </div>

              <div className="benefit">
                <div className="benefit-icon">✓</div>

                <div>
                  <h4>Get discovered by organizations</h4>
                  <p>
                    Let organizations find students with the right skills.
                  </p>
                </div>
              </div>

            </div>

          </div>

          <div className="intro-footer">
            <span>© 2026 Advenware Careere Link</span>
            <span>Students • Opportunities • Careers</span>
          </div>

        </div>

      </section>

      {/* RIGHT SIDE */}
      <section className="register-form-container">

        <div className="form-wrapper">

          <div className="mobile-brand">
            <div className="brand-icon">
              <span>AC</span>
            </div>

            <div>
              <h2>Advenware</h2>
              <p>Careere Link</p>
            </div>
          </div>

          <div className="form-header">

            <div className="step">
              STEP 01 / 01
            </div>

            <h1>Create your student account</h1>

            <p>
              Complete your profile to start discovering attachment
              opportunities.
            </p>

          </div>

          <form onSubmit={handleSubmit}>

            {/* PERSONAL INFORMATION */}

            <div className="section-title">
              <div className="section-number">01</div>

              <div>
                <h3>Personal information</h3>
                <p>Tell us a little about yourself.</p>
              </div>
            </div>

            <div className="form-grid">

              <div className="input-group full-width">
                <label>
                  Full name <span>*</span>
                </label>

                <div className="input-container">
                  <span className="input-icon">◉</span>

                  <input
                    type="text"
                    name="fullName"
                    placeholder="e.g. Kevin Mukoya"
                    value={formData.fullName}
                    onChange={handleChange}
                  />
                </div>

                {errors.fullName && (
                  <small className="error">
                    {errors.fullName}
                  </small>
                )}
              </div>

              <div className="input-group">

                <label>
                  National ID / Passport <span>*</span>
                </label>

                <div className="input-container">
                  <span className="input-icon">▣</span>

                  <input
                    type="text"
                    name="idNumber"
                    placeholder="ID number"
                    value={formData.idNumber}
                    onChange={handleChange}
                  />
                </div>

                {errors.idNumber && (
                  <small className="error">
                    {errors.idNumber}
                  </small>
                )}

              </div>

               {/* EMAIL */}

            <div className="login-input-group">

              <label>
                Email address <span>*</span>
              </label>

              <div className="login-input-container">

                <span className="login-input-icon">
                  @
                </span>

                <input
                  type="email"
                  name="email"
                  placeholder="you@example.com"
                  value={formData.email}
                  onChange={handleChange}
                  autoComplete="email"
                />

              </div>

              {errors.email && (
                <small className="login-error">
                  {errors.email}
                </small>
              )}

            </div>

              <div className="input-group">

                <label>
                  Phone number <span>*</span>
                </label>

                <div className="input-container">
                  <span className="input-icon">☎</span>

                  <input
                    type="tel"
                    name="phone"
                    placeholder="07XX XXX XXX"
                    value={formData.phone}
                    onChange={handleChange}
                  />
                </div>

                {errors.phone && (
                  <small className="error">
                    {errors.phone}
                  </small>
                )}

              </div>

            </div>


            {/* EDUCATION */}

            <div className="section-title">

              <div className="section-number">02</div>

              <div>
                <h3>Education & placement</h3>
                <p>Help us find the right opportunity for you.</p>
              </div>

            </div>

            <div className="form-grid">

              <div className="input-group">

                <label>
                  Institute / University <span>*</span>
                </label>

                <div className="input-container">

                  <span className="input-icon">▤</span>

                  <input
                    type="text"
                    name="institution"
                    placeholder="e.g. University of Nairobi"
                    value={formData.institution}
                    onChange={handleChange}
                  />

                </div>

                {errors.institution && (
                  <small className="error">
                    {errors.institution}
                  </small>
                )}

              </div>


              <div className="input-group">

                <label>
                  Current course <span>*</span>
                </label>

                <div className="input-container">

                  <span className="input-icon">◇</span>

                  <input
                    type="text"
                    name="course"
                    placeholder="e.g. Computer Science"
                    value={formData.course}
                    onChange={handleChange}
                  />

                </div>

                {errors.course && (
                  <small className="error">
                    {errors.course}
                  </small>
                )}

              </div>


              <div className="input-group">

                <label>
                  County where you want placement <span>*</span>
                </label>

                <div className="input-container">

                  <span className="input-icon">⌖</span>

                  <select
                    name="placementCounty"
                    value={formData.placementCounty}
                    onChange={handleChange}
                  >

                    <option value="">
                      Select placement county
                    </option>

                    {counties.map((county) => (
                      <option
                        value={county}
                        key={county}
                      >
                        {county}
                      </option>
                    ))}

                  </select>

                </div>

                {errors.placementCounty && (
                  <small className="error">
                    {errors.placementCounty}
                  </small>
                )}

              </div>


              <div className="input-group">

                <label>
                  Current county <span>*</span>
                </label>

                <div className="input-container">

                  <span className="input-icon">⌖</span>

                  <select
                    name="currentCounty"
                    value={formData.currentCounty}
                    onChange={handleChange}
                  >

                    <option value="">
                      Where are you currently?
                    </option>

                    {counties.map((county) => (
                      <option
                        value={county}
                        key={county}
                      >
                        {county}
                      </option>
                    ))}

                  </select>

                </div>

                {errors.currentCounty && (
                  <small className="error">
                    {errors.currentCounty}
                  </small>
                )}

              </div>

            </div>


            {/* CV */}

            <div className="section-title">

              <div className="section-number">03</div>

              <div>
                <h3>Your CV</h3>
                <p>Upload your latest CV for employers to view.</p>
              </div>

            </div>


            <div className="cv-upload">

              <input
                type="file"
                id="cv"
                accept=".pdf,.doc,.docx"
                onChange={handleCVUpload}
              />

              <label htmlFor="cv">

                <div className="upload-icon">
                  ↑
                </div>

                <div className="upload-text">

                  {cv ? (
                    <>
                      <strong>{cv.name}</strong>

                      <span>
                        {(cv.size / 1024 / 1024).toFixed(2)} MB
                      </span>
                    </>
                  ) : (
                    <>
                      <strong>
                        Click to upload your CV
                      </strong>

                      <span>
                        PDF, DOC or DOCX • Maximum 5MB
                      </span>
                    </>
                  )}

                </div>

                <div className="browse">
                  Browse
                </div>

              </label>

            </div>

            {errors.cv && (
              <small className="error cv-error">
                {errors.cv}
              </small>
            )}


     


  


            {/* PASSWORD */}

            <div className="section-title">

              <div className="section-number">05</div>

              <div>
                <h3>Secure your account</h3>
                <p>Create a strong password for your account.</p>
              </div>

            </div>


            <div className="form-grid">

              <div className="input-group">

                <label>
                  New password <span>*</span>
                </label>

                <div className="input-container">

                  <span className="input-icon">◆</span>

                  <input
                    type={
                      showPassword
                        ? "text"
                        : "password"
                    }
                    name="password"
                    placeholder="At least 8 characters"
                    value={formData.password}
                    onChange={handleChange}
                  />

                  <button
                    type="button"
                    className="password-toggle"
                    onClick={() =>
                      setShowPassword(!showPassword)
                    }
                  >
                    {showPassword ? "Hide" : "Show"}
                  </button>

                </div>

                {errors.password && (
                  <small className="error">
                    {errors.password}
                  </small>
                )}

              </div>


              <div className="input-group">

                <label>
                  Confirm password <span>*</span>
                </label>

                <div className="input-container">

                  <span className="input-icon">◆</span>

                  <input
                    type={
                      showConfirmPassword
                        ? "text"
                        : "password"
                    }
                    name="confirmPassword"
                    placeholder="Repeat your password"
                    value={formData.confirmPassword}
                    onChange={handleChange}
                  />

                  <button
                    type="button"
                    className="password-toggle"
                    onClick={() =>
                      setShowConfirmPassword(
                        !showConfirmPassword
                      )
                    }
                  >
                    {showConfirmPassword
                      ? "Hide"
                      : "Show"}
                  </button>

                </div>

                {errors.confirmPassword && (
                  <small className="error">
                    {errors.confirmPassword}
                  </small>
                )}

              </div>

            </div>


            {/* SUBMIT */}

            <div className="submit-area">

              <p className="terms">
                By creating an account, you agree to the
                Advenware Careere Link terms of service
                and privacy policy.
              </p>

              <button
                type="submit"
                className="create-account-button"
                disabled={isSubmitting}
              >

                {isSubmitting
                  ? "Creating account..."
                  : "Create my account →"}

              </button>

              <p className="login-text">
                Already have an account?
                <button
                  type="button"
                onClick={() => handleNavigation("login")}
                >
                  Sign in
                </button>
              </p>

            </div>

          </form>

        </div>

      </section>

    </div>
  );
};

export default CreateAccount;